
import axios from 'axios';


export default {
  /**
   * 列出检测报告
   * @param {*} params 
   */
  getAdvert(params) {
    return axios.get(`/api/advertising/`, {params:params})
  },

}


// WEBPACK FOOTER //
// ./src/api/advert.js